import { ScheduleEntryState, Task, TaskType, Timestamp } from '@griply/types';
import { isSameDay } from 'date-fns';

import { getActiveSchedule } from './schedules';

export const isHabitCompletedOnDay = (task: Task, day: Timestamp): boolean => {
  if (![TaskType.Habit, TaskType.Repeating].includes(task.type)) {
    return false;
  }

  const activeSchedule = getActiveSchedule(task.schedules, day);
  if (!activeSchedule) {
    return false;
  }

  return !!activeSchedule.entries.find(
    (entry) =>
      entry.state === ScheduleEntryState.Complete &&
      !!entry.value &&
      isSameDay(entry.date, day),
  );
};
